import { clsx } from 'clsx';
import { FC } from 'react';
import { UserBadgeFragmentFragment } from '@/__generated__/graphql.ts';
import { S3Avatar } from '@/components/s3/user/s3-avatar.tsx';
import {
  streamAuthor,
  streamCardUsername,
  streamAuthorUsernameContainer,
} from '@/components/streams/stream-author/stream-author.css.ts';
import { userAvatar } from '@/components/user-badge/user-badge.css.ts';

export const StreamAuthor: FC<{
  author: UserBadgeFragmentFragment;
  className?: string;
  usernameContainerClassName?: string;
}> = ({ author, usernameContainerClassName, className }) => {
  return (
    <div className={clsx(streamAuthor, className)}>
      <S3Avatar
        className={userAvatar}
        size={'small'}
        s3Key={author.avatar?.key}
        userId={author.id}
      />
      <div
        className={clsx(
          streamAuthorUsernameContainer,
          usernameContainerClassName,
        )}
      >
        <span className={streamCardUsername}>@{author.username}</span>
      </div>
    </div>
  );
};
